import { useTimeoutState } from "@stenajs-webui/core";
import { ActionMenuItem, stenaCopy } from "@stenajs-webui/elements";
import type { FC } from "react";

interface CommonActionMenuItemProps {
  disabled?: boolean;
  getValue: () => string;
  onClick: () => void;
}
export const CopyActionMenuItem: FC<CommonActionMenuItemProps> = ({
  disabled,
  getValue,
  onClick,
}) => {
  const [showCopyClicked, setShowCopyClicked] = useTimeoutState(false, 2000);

  const onClickItem = () => {
    setShowCopyClicked(true);
    navigator.clipboard.writeText(getValue());
    onClick();
  };

  return (
    <ActionMenuItem
      label={showCopyClicked ? "Copied" : "Copy to clipboard"}
      leftIcon={stenaCopy}
      variant={showCopyClicked ? "success" : undefined}
      success={showCopyClicked}
      disableCloseOnClick
      onClick={onClickItem}
      disabled={disabled}
    />
  );
};
